/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};

type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const fiRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Pyydä koulun lisäämistä',
    description: 'Ole hyvä ja täytä alla oleva lomake. Hakemuksen jättäneiden koulujen lisäämistä ei voida taata, mutta SheerID tutkii ja käsittelee jokaisen pyynnön. ',
    noCountry: 'Etkö löydä oman koulusi maata? Et ole oikeutettu tähän tarjoukseen',
    searchByOrgName: 'Etkö löydä omaa kouluasi? Etsi nimen perusteella',
    completeRequest: 'Etkö löydä omaa kouluasi edellytysten täyttävien koulujen listasta tai niiden koulujen listasta, jotka eivät täytä edellytyksiä? Täydennä pyyntöäsi',
    submit: 'Lähetä',
    eligibleOrgs: 'Koulut, jotka täyttävät edellytykset. Kopioi nimi napsauttamalla kuvaketta ja palaa sitten vahvistuslomakkeeseen',
    ineligibleOrgs: 'Koulut, jotka eivät täytä edellytyksiä. Valitettavasti näiden koulujen oppilaat eivät ole oikeutettuja tähän tarjoukseen',
    none: 'Ei mitään',
    country: 'Missä käyt koulua?',
    changeLanguage: 'Vaihda kieltä',
    copied: 'kopioitu',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    emailAddress: 'Sähköposti',
    poweredBy: 'SheerID tarjoaa varmennuspalvelut',
    fields: {
        countryPlaceholder: 'Valitse maa',
        domainLabel: 'Koulun kotisivut',
        domainPlaceholder: 'www.minunkouluni.fi',
        orgNameLabel: 'Koulun nimi',
        orgNamePlaceholder: 'Minun kouluni',
    },
    step: {
        success: {
            title: 'Kiitos koulupyyntösi lähettämisestä',
            description: 'Muistutuksena ilmoitamme, että SheerID arvioi jokaisen pyynnön tämän tarjouksen vaatimusten mukaisesti. Emme takaa, että oppilaitoksesi hyväksytään. Arviointiprosessi kestää enintään seitsemän päivää.',
        },
        error: { title: 'Tapahtui odottamaton virhe',
            description: 'Valitettavasti emme voi käsitellä pyyntöäsi. Ole hyvä ja yritä myöhemmin uudelleen.',
            seeingProblem: 'Jos tämä ongelma toistuu',
            contactUs: 'ota meihin yhteyttä',
        },
    },
    errorId: {
        invalidCountry: 'Pakollinen kenttä',
        invalidEmail: 'Virheellinen sähköposti',
        invalidFirstName: 'Virheellinen etunimi',
        invalidLastName: 'Virheellinen sukunimi',
        requiredField: 'Pakollinen kenttä',
        invalidField: 'Virheellinen kenttä',
        invalidUrl: 'Virheellinen osoite',
        tooManyResults: 'Hakusi tuotti liian monta tulosta. Tarkenna hakuasi ja yritä uudelleen',
    },
    faq: 'SheerID lisää koulupyyntö FAQ',
    countries: {
        AD: 'Andorra',
        AE: 'Yhdistyneet arabiemiirikunnat',
        AF: 'Afganistan',
        AG: 'Antigua ja Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Alankomaiden Antillit',
        AO: 'Angola',
        AR: 'Argentiina',
        AS: 'Amerikan Samoa',
        AT: 'Itävalta',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaidžan',
        BA: 'Bosnia ja Hertsegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgia',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei',
        BO: 'Bolivia',
        BR: 'Brasilia',
        BS: 'Bahama',
        BT: 'Bhutan',
        BV: 'Bouvet’nsaari',
        BW: 'Botswana',
        BY: 'Valko-Venäjä',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Kongon demokraattinen tasavalta',
        CF: 'Keski-Afrikan tasavalta',
        CG: 'Kongo',
        CH: 'Sveitsi',
        CI: 'Norsunluurannikko',
        CK: 'Cookinsaaret',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Kiina',
        CO: 'Kolumbia',
        CR: 'Costa Rica',
        CU: 'Kuuba',
        CV: 'Kap Verde',
        CY: 'Kypros',
        CZ: 'Tšekki',
        DE: 'Saksa',
        DJ: 'Djibouti',
        DK: 'Tanska',
        DM: 'Dominica',
        DO: 'Dominikaaninen tasavalta',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Viro',
        EG: 'Egypti',
        EH: 'Länsi-Sahara',
        ER: 'Eritrea',
        ES: 'Espanja',
        ET: 'Etiopia',
        FI: 'Suomi',
        FJ: 'Fidži',
        FK: 'Falklandinsaaret',
        FM: 'Mikronesia',
        FO: 'Färsaaret',
        FR: 'Ranska',
        GA: 'Gabon',
        GB: 'Yhdistynyt kuningaskunta',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'Ranskan Guayana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grönlanti',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (Ranska)',
        GQ: 'Päiväntasaajan Guinea',
        GR: 'Kreikka',
        GS: 'Etelä-Georgia ja Eteläiset Sandwichsaaret',
        GT: 'Guatemala',
        GU: 'Guam (Yhdysvallat)',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Heard ja McDonaldinsaaret',
        HN: 'Honduras',
        HR: 'Kroatia',
        HT: 'Haiti',
        HU: 'Unkari',
        ID: 'Indonesia',
        IE: 'Irlanti',
        IL: 'Israel',
        IN: 'Intia',
        IO: 'Brittiläinen Intian valtameren alue',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Islanti',
        IT: 'Italia',
        JM: 'Jamaika',
        JO: 'Jordania',
        JP: 'Japani',
        KE: 'Kenia',
        KG: 'Kirgisia',
        KH: 'Kambodža',
        KI: 'Kiribati',
        KM: 'Komorit',
        KN: 'Saint Kitts ja Nevis',
        KP: 'Pohjois-Korea',
        KR: 'Etelä-Korea',
        KW: 'Kuwait',
        KY: 'Caymansaaret',
        KZ: 'Kazakstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Liettua',
        LU: 'Luxemburg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldova',
        ME: 'Montenegro',
        MG: 'Madagaskar',
        MH: 'Marshallinsaaret',
        MK: 'Makedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macao',
        MP: 'Pohjois-Mariaanit',
        MQ: 'Martinique (Ranska)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediivit',
        MW: 'Malawi',
        MX: 'Meksiko',
        MY: 'Malesia',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NC: 'Uusi-Kaledonia (Ranska)',
        NE: 'Niger',
        NF: 'Norfolkinsaari',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Alankomaat',
        NO: 'Norja',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Uusi-Seelanti',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (Ranska)',
        PG: 'Papua-Uusi-Guinea',
        PH: 'Filippiinit',
        PK: 'Pakistan',
        PL: 'Puola',
        PM: 'Saint-Pierre ja Miquelon',
        PN: 'Pitcairnsaaret',
        PR: 'Puerto Rico',
        PS: 'Palestiina',
        PT: 'Portugali',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Réunion (Ranska)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Venäjä',
        RW: 'Ruanda',
        SA: 'Saudi-Arabia',
        SB: 'Salomonsaaret',
        SC: 'Seychellit',
        SD: 'Sudan',
        SE: 'Ruotsi',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SK: 'Slovakia',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'Eteläsudan',
        ST: 'São Tomé ja Príncipe',
        SV: 'El Salvador',
        SY: 'Syyria',
        SZ: 'Swazimaa',
        TC: 'Turks- ja Caicossaaret',
        TD: 'Tšad',
        TF: 'Ranskan eteläiset alueet',
        TG: 'Togo',
        TH: 'Thaimaa',
        TJ: 'Tadžikistan',
        TK: 'Tokelau',
        TL: 'Itä-Timor',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkki',
        TT: 'Trinidad ja Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tansania',
        UA: 'Ukraina',
        UG: 'Uganda',
        UM: 'Yhdysvaltojen pienet syrjäiset saaret',
        US: 'Yhdysvallat',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatikaanivaltio',
        VC: 'Saint Vincent ja Grenadiinit',
        VE: 'Venezuela',
        VG: 'Neitsytsaaret (Iso-Britannia)',
        VI: 'Neitsytsaaret (Yhdysvallat)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis ja Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Etelä-Afrikka',
        ZM: 'Sambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'arabia',
        bg: 'bulgaria',
        cs: 'tšekki',
        da: 'tanska',
        de: 'saksa',
        el: 'kreikka',
        'en-GB': 'englanti (Iso-Britannia)',
        'en-US': 'englanti',
        'es-ES': 'espanja (Espanja)',
        es: 'Espanja',
        fi: 'suomi',
        'fr-CA': 'ranska (Kanada)',
        fr: 'ranska',
        hr: 'kroaatti',
        hu: 'unkari',
        id: 'indonesia',
        is: 'islanti',
        it: 'italia',
        iw: 'heprea',
        ja: 'japani',
        ko: 'korea',
        lt: 'liettua',
        ms: 'malaiji',
        nl: 'hollanti',
        no: 'norja',
        pl: 'puola',
        'pt-BR': 'portugali (Brasilia)',
        pt: 'portugali',
        ro: 'romania',
        ru: 'venäjä',
        sk: 'slovakki',
        sl: 'sloveeni',
        sr: 'serbia',
        sv: 'ruotsi',
        tr: 'turkki',
        'zh-HK': 'kiina (Hongkong)',
        zh: 'kiina (perinteinen)',
    },
};
